import React from "react"
import PropTypes from "prop-types"
import LimitedTextInput from "shared/limited_text_input"

export default function AppletTitle({ applet, onNameChange }) {
  let logLink

  if (applet.status === "enabled_for_user") {
    logLink = (
      <a className="logs" href={`/activity/applet/${applet.id}`}>
        View activity log
      </a>
    )
  }

  if (applet.can_change_name) {
    return (
      <div className="diy-description">
        <LimitedTextInput
          name="name"
          value={applet.name}
          limit={140}
          onChange={onNameChange}
        />
        <p className="description">{applet.description}</p>
        {logLink}
      </div>
    )
  }

  return (
    <div>
      <h2>{applet.name}</h2>
      <p className="description">{applet.description}</p>
      {logLink}
    </div>
  )
}

AppletTitle.propTypes = {
  applet: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    can_change_name: PropTypes.bool,
    description: PropTypes.string,
  }).isRequired,
  onNameChange: PropTypes.func,
}

AppletTitle.defaultProps = {
  onNameChange: () => {},
}
